export default __webpack_public_path__ + "static/media/Plus.0687a95a.svg";